@if (variantService.isRedesign) {
  <app-shell-v2 [loginURL]="loginURL$ | async"></app-shell-v2>
} @else {
  <app-shell-v1 [loginURL]="loginURL$ | async"></app-shell-v1>
}
